export enum ChecklistItemType {
    Integer = 0,
    YesNo = 1,
    Done = 2,
}

